import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiScissors,FiStar,FiMapPin,FiPhone,FiClock,FiCheck,FiUser,FiCalendar}=FiIcons;

function Home() {
  const features=[
    {icon: FiScissors,title: 'Expert Barbers',description: 'Skilled professionals with years of experience in traditional and modern barbering techniques.'},
    {icon: FiStar,title: 'Premium Service',description: 'High-quality grooming services using the finest tools and products for exceptional results.'},
    {icon: FiClock,title: 'Convenient Hours',description: 'Open 7 days a week with flexible scheduling to fit your busy lifestyle.'}
  ];

  const testimonials=[
    {name: "James Wilson",role: "Regular Client",text: "Best fade I've had in Toronto. The attention to detail is unmatched,and the atmosphere is exactly what a barbershop should be.",rating: 5},
    {name: "Marcus Chen",role: "Local Resident",text: "Found this gem in the West End and haven't looked back. The hot towel shave is an absolute must-try experience.",rating: 5},
    {name: "David Thompson",role: "Professional",text: "Great vibe,professional staff,and they always run on time. Highly recommend for anyone looking for a sharp cut.",rating: 5}
  ];

  const popularServices=[
    {name: "Skin Fade",price: "$40",description: "Precision fade with razor line-up and styling."},
    {name: "Beard Sculpting",price: "$25",description: "Hot towel,shape-up,and beard oil treatment."},
    {name: "The Executive",price: "$65",description: "Full haircut,beard trim,and hot towel finish."}
  ];

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} transition={{duration: 0.5}} className="flex-1" >
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
        <div className="absolute inset-0 bg-black/60 z-0"></div>
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30 z-[-1]" style={{backgroundImage: 'url(https://i.ibb.co/FqL7gxFW/images-1.jpg)'}} ></div>
        
        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
          <motion.div initial={{y: 30,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} className="flex items-center justify-center mb-6" >
            <span className="px-4 py-1 border border-yellow-500/50 rounded-full text-yellow-400 text-sm uppercase tracking-widest bg-black/50 backdrop-blur-sm">
              Est. 2010 • Toronto
            </span>
          </motion.div>

          <motion.h1 initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.3,duration: 0.8}} className="text-5xl sm:text-7xl lg:text-8xl font-bold mb-6 tracking-tight" >
            <span className="text-white">West End</span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
              Barbers
            </span>
          </motion.h1>
          
          <motion.p initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.5,duration: 0.8}} className="text-xl sm:text-2xl text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto" >
            Where traditional craftsmanship meets modern style. Experience the premier grooming destination in Toronto's West End.
          </motion.p>
          
          <motion.div initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.7,duration: 0.8}} className="flex flex-col sm:flex-row gap-4 justify-center" >
            <Link to="/services" className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-black px-8 py-4 rounded-lg font-bold text-lg hover:shadow-lg hover:shadow-yellow-500/20 transform hover:scale-105 transition-all duration-300">
              View Our Services
            </Link>
            <a href="tel:+14166379929" className="px-8 py-4 rounded-lg font-bold text-lg border-2 border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black transition-all duration-300">
              Book Appointment
            </a>
          </motion.div>
        </div>
      </section>

      {/* About Teaser Section */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div initial={{x: -50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="relative" >
              <div className="absolute -inset-4 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-lg opacity-20 blur-lg"></div>
              <img src="https://i.ibb.co/vCmDP3wK/images-11.jpg" alt="Barbershop Interior" className="relative rounded-lg shadow-2xl border border-gray-800 w-full object-cover h-[500px]" />
              <div className="absolute -bottom-6 -right-6 bg-gray-900 p-6 rounded-lg border border-yellow-500/20 shadow-xl hidden sm:block">
                <div className="flex items-center gap-4">
                  <div className="bg-yellow-400/10 p-3 rounded-full">
                    <SafeIcon icon={FiUser} className="w-8 h-8 text-yellow-400" />
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">15+</p>
                    <p className="text-sm text-gray-400">Years Experience</p>
                  </div>
                </div>
              </div>
            </motion.div>
            
            <motion.div initial={{x: 50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} >
              <h2 className="text-yellow-400 font-bold tracking-wider uppercase mb-2">Who We Are</h2>
              <h3 className="text-4xl sm:text-5xl font-bold text-white mb-6">More Than Just a <br/>Haircut</h3>
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                At West End Barbers,we believe that a haircut is not just a service,but an experience. Located in the heart of Toronto,our shop combines the nostalgic feel of a classic barbershop with modern grooming techniques.
              </p>
              <p className="text-gray-400 text-lg leading-relaxed mb-8">
                Whether you're looking for a classic gentleman's cut,a modern fade,or a relaxing hot towel shave,our expert barbers are dedicated to helping you look and feel your absolute best.
              </p>
              
              <div className="grid grid-cols-2 gap-6 mb-8">
                <div className="flex items-center gap-3">
                  <SafeIcon icon={FiCheck} className="text-yellow-400 w-5 h-5 flex-shrink-0" />
                  <span className="text-gray-300">Master Barbers</span>
                </div>
                <div className="flex items-center gap-3">
                  <SafeIcon icon={FiCheck} className="text-yellow-400 w-5 h-5 flex-shrink-0" />
                  <span className="text-gray-300">Premium Products</span>
                </div>
                <div className="flex items-center gap-3">
                  <SafeIcon icon={FiCheck} className="text-yellow-400 w-5 h-5 flex-shrink-0" />
                  <span className="text-gray-300">Relaxing Atmosphere</span>
                </div>
                <div className="flex items-center gap-3">
                  <SafeIcon icon={FiCheck} className="text-yellow-400 w-5 h-5 flex-shrink-0" />
                  <span className="text-gray-300">Complimentary Drinks</span>
                </div>
              </div>

              <Link to="/about" className="text-yellow-400 font-semibold hover:text-white transition-colors duration-200 flex items-center gap-2 group" >
                Learn More About Us 
                <span className="group-hover:translate-x-1 transition-transform duration-200">→</span>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-24 bg-gray-900 border-y border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Popular Services</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">Top-tier grooming services chosen by our clients.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {popularServices.map((service,index)=> (
              <motion.div key={index} initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: index * 0.1,duration: 0.5}} viewport={{once: true}} className="bg-black p-8 rounded-lg border border-yellow-500/10 hover:border-yellow-500/40 transition-all duration-300 group" >
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-2xl font-bold text-white group-hover:text-yellow-400 transition-colors">{service.name}</h3>
                  <span className="text-xl font-bold text-yellow-400">{service.price}</span>
                </div>
                <p className="text-gray-400 mb-6">{service.description}</p>
                <Link to="/services" className="text-sm font-bold text-white uppercase tracking-wider border-b border-yellow-400 pb-1 hover:text-yellow-400 transition-colors inline-block">
                  Book Now
                </Link>
              </motion.div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link to="/services" className="inline-block px-8 py-3 border border-gray-600 rounded-lg text-gray-300 hover:border-yellow-400 hover:text-yellow-400 transition-all duration-300">
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="text-center mb-16" >
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              The West End Experience
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Why our clients keep coming back
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature,index)=> (
              <motion.div key={index} initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: index * 0.2,duration: 0.8}} viewport={{once: true}} className="text-center p-8 bg-gray-900/50 rounded-xl border border-gray-800 hover:border-yellow-500/30 transition-all duration-300" >
                <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg shadow-yellow-500/20">
                  <SafeIcon icon={feature.icon} className="h-10 w-10 text-black" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-yellow-500/20 to-transparent"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">Client Stories</h2>
            <p className="text-gray-400">Don't just take our word for it.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial,index)=> (
              <motion.div key={index} initial={{opacity: 0,scale: 0.9}} whileInView={{opacity: 1,scale: 1}} transition={{delay: index * 0.1,duration: 0.5}} viewport={{once: true}} className="bg-black p-8 rounded-xl border border-gray-800 relative" >
                <div className="absolute top-6 right-8 text-yellow-500/20 text-6xl font-serif">"</div>
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_,i)=> (
                    <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-gray-300 mb-6 italic relative z-10">"{testimonial.text}"</p>
                <div>
                  <h4 className="text-white font-bold">{testimonial.name}</h4>
                  <p className="text-yellow-500/80 text-sm">{testimonial.role}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="py-24 bg-black border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div initial={{x: -50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} >
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                Visit Our Shop
              </h2>
              <p className="text-xl text-gray-400 mb-8">
                Located in the vibrant Toronto West End. Drop by for a fresh cut or call us to book your spot.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-gray-900 p-3 rounded-lg mr-4">
                    <SafeIcon icon={FiMapPin} className="h-6 w-6 text-yellow-400" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Address</h4>
                    <span className="text-gray-400">2925 Dundas St W,Toronto,ON M6P 1Z1</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-gray-900 p-3 rounded-lg mr-4">
                    <SafeIcon icon={FiPhone} className="h-6 w-6 text-yellow-400" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Phone</h4>
                    <a href="tel:+14166379929" className="text-gray-400 hover:text-yellow-400 transition-colors duration-200">
                      +1 (416) 637-9929
                    </a>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-gray-900 p-3 rounded-lg mr-4">
                    <SafeIcon icon={FiCalendar} className="h-6 w-6 text-yellow-400" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Hours</h4>
                    <span className="text-gray-400">Mon - Sun: 09:00 AM - 08:00 PM</span>
                  </div>
                </div>
              </div>

              <div className="mt-10 flex gap-4">
                <Link
                  to="/contact"
                  className="bg-white text-black px-8 py-3 rounded-lg font-bold hover:bg-yellow-400 transition-colors duration-300"
                >
                  Get Directions
                </Link>
                <a
                  href="tel:+14166379929"
                  className="px-8 py-3 rounded-lg font-bold border border-gray-600 text-white hover:border-yellow-400 hover:text-yellow-400 transition-all duration-300"
                >
                  Call Now
                </a>
              </div>
            </motion.div>

            <motion.div initial={{x: 50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="rounded-xl overflow-hidden border border-gray-800 shadow-2xl" >
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2886.169943683877!2d-79.4669212!3d43.665435300000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b351e0d005825%3A0xae115751961f63df!2sWest%20End%20Barbers!5e0!3m2!1sen!2s!4v1764169491295!5m2!1sen!2s" 
                width="100%" 
                height="450" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-[450px] bg-gray-900"
              ></iframe>
            </motion.div>
          </div>
        </div>
      </section>
    </motion.div>
  );
}

export default Home;